<section class="p-3">

  <lib-dialog-header
    [titulok]="'Detail atribútov predmetu' | translate"
    [predmetNazov]="predmet.predmetNazov"
    [predmetSkratka]="predmet.predmetSkratka">
  </lib-dialog-header>

  <mat-dialog-content class="mat-typography p-1 p-sm-3">

    <div>

      <dl>

        <dt i18n>Počet kreditov</dt>
        <dd>{{predmet.kredit}}</dd>

        <dt i18n>Semester</dt>
        <dd>{{predmet.kodSemester}}S - {{getPopisSemester()}}</dd>

        <dt i18n>Spôsob ukončenia</dt>
        <dd>{{predmet.kodSposobUkoncenia}} - {{predmet.popisSposobUkoncenia}}</dd>

      </dl>

    </div>

<!--
    <div class="container">

      <div class="row">
        <div class="col-2 fw-bold">Počet kreditov</div>
        <div class="col-10">{{predmet.kredit}}</div>
      </div>

      <div class="row">
        <div class="col-2 fw-bold">Semester</div>
        <div class="col-10">{{predmet.kodSemester}}S - {{getPopisSemester()}}</div>
      </div>

      <div class="row">
        <div class="col-2 fw-bold">Spôsob ukončenia</div>
        <div class="col-10">{{predmet.kodSposobUkoncenia}} - {{predmet.popisSposobUkoncenia}}</div>
      </div>

    </div>

  -->


  </mat-dialog-content>

  <!-- <hr/> -->

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>
